import { graphql } from '@generated/gql';

export const FETCH_ARCHIVE_ACCOUNTS = graphql(/** GraphQL */ `
  query fetchArchiveAccounts($input: FetchAccountsInput!) {
    fetchAccounts(input: $input) {
      accounts {
        id: stringId
        translatedAccountType {
          en
          fr
          es
        }
        stateTranslated {
          en
          fr
          es
        }
      }
    }
  }
`);

export const FETCH_ARCHIVE_GOAL = graphql(/** GraphQL */ `
  query fetchArchiveGoal($goalId: ObjectID!) {
    fetchGoal(goalId: $goalId) {
      goal {
        id
        name
      }
    }
  }
`);

export const FETCH_ARCHIVE_SUB_ACCOUNT = graphql(/** GraphQL */ `
  query fetchArchiveSubAccount($subAccountId: ObjectID!) {
    fetchSubAccount(subAccountId: $subAccountId) {
      subAccount {
        id
        goal {
          name
        }
        account {
          translatedAccountType {
            en
            fr
            es
          }
        }
      }
    }
  }
`);

export const FETCH_ARCHIVE_TRANSFERS = graphql(/** GraphQL */ `
  query fetchArchiveTransfers($input: FetchTransfersInput!) {
    fetchTransfers(input: $input) {
      transfers {
        id
        typeTranslated {
          en
          fr
          es
        }
        amountCents
        currency
      }
    }
  }
`);

export const FETCH_ARCHIVE_SCHEDULED_TRANSFER = graphql(/** GraphQL */ `
  query fetchArchiveScheduledTransfer($scheduledTransferId: ObjectID!) {
    fetchScheduledTransfer(scheduledTransferId: $scheduledTransferId) {
      scheduledTransfer {
        id
        typeTranslated {
          en
          fr
          es
        }
        amountCents
        currency
      }
    }
  }
`);

export const FETCH_ARCHIVE_MANUAL_PROCESS = graphql(/** GraphQL */ `
  query fetchArchiveManualProcess($id: ID!) {
    fetchManualProcess(id: $id) {
      manualProcess {
        id
        type
        institution {
          name
        }
        transferMethod
      }
    }
  }
`);
